var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-header',{staticClass:"bg-white",staticStyle:{"z-index":"1000","position":"fixed"}}),_c('router-view',{staticClass:"pt-sm-5 pt-5",staticStyle:{"z-index":"-1"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }